<template>
  <div>
    <div>
      <j-employee-form-update
        ref="employeeForm"
        mode="update"
        @data="getData"/>
    </div>

    <b-row>
      <b-col
        sm="12"
        md="9">
        <div class="m__t--20">
          <!-- <b-button
            class="btn red"
            @click="deletedEmployee">Delete</b-button> -->
          <b-button
            class="btn blue"
            @click="saveUpdateEmployee">Update</b-button>
        </div>
      </b-col>
      <b-col
        sm="12"
        md="3"/>
    </b-row>
    <br>
  </div>
</template>

<script>
/* eslint-disable max-len */
import jEmployeeFormUpdate from '@/views/user-employee/detail/jEmployeeFormUpdate';
import { mapActions } from 'vuex';

export default {
  components: {
    jEmployeeFormUpdate,
  },
  data() {
    return {
      employee_data: null,
    };
  },
  computed: {
    generateData() {
      const dataSecMapp = [];
      this.employee_data.secretary_mode_mapping.forEach((val) => {
        dataSecMapp.push(val.id);
      });
      const genData = {
        id: this.employee_data.id,
        email: this.employee_data.email,
        employee_id: this.employee_data.employee_id,
        personal_email: this.employee_data.personal_email,
        password: this.employee_data.password ? this.employee_data.password : '',
        first_name: this.employee_data.first_name,
        last_name: this.employee_data.last_name ? this.employee_data.last_name : '',
        group_id: this.employee_data.teams ? this.employee_data.teams.id : 0,
        user_role: this.employee_data.role ? this.employee_data.role.id : null,
        code: this.employee_data.code,
        join_date: this.employee_data.join_date,
        resign_date: this.employee_data.end_date,
        photo_url: this.employee_data.photo,
        phone_number: this.employee_data.phone_number,
        date_of_birth: this.employee_data.date_of_birth,
        place_of_birth: this.employee_data.place_of_birth,
        bank_account_name: this.employee_data.bank_name ? this.employee_data.bank_name.name : '',
        bank_account_number: this.employee_data.bank_account_number,
        bank_account_owner: this.employee_data.bank_account_holder_name,
        bank_account_branch: this.employee_data.bank_account_branch,
        contract_type: this.employee_data.employment_type ? this.employee_data.employment_type : '',
        type_of_contract: this.employee_data.contract_type ? this.employee_data.contract_type : '',
        active_reason: this.employee_data.active_reason ? this.employee_data.active_reason : '',
        non_active_reason: this.employee_data.nonactive_reason ? this.employee_data.nonactive_reason : '',
        secretary_mode: this.employee_data.secretary_mode,
        secretary_mode_list_team: dataSecMapp,
        country_id: this.employee_data.country ? this.employee_data.country.id : 0,
        employee_status: this.employee_data.employee_status ? 1 : 0,
        other_name: this.employee_data.other_name,
        gender: this.employee_data.gender,
        nationality_type: this.employee_data.nationality_type ? this.employee_data.nationality_type : null,
        identity_type: this.employee_data.id_type ? this.employee_data.id_type.text : '',
        passport_expired_date: this.employee_data.exp_date ? this.employee_data.exp_date : '',
        identity_no: this.employee_data.id_number,
        fax_number: 0,
        religion: this.employee_data.religion,
        marital_status: this.employee_data.marital_status,
        home_address: this.employee_data.home_address,
        postal_code: this.employee_data.postal_code,
        about: this.employee_data.notes,
        title: '',
        tax_identification_number: 0,
        bpjs_ketenagakerjaan: '',
        bpjs_kesehatan: '',
        ptkp: '',
        max_disbursed_count: 0,
        province_id: this.employee_data.province ? this.employee_data.province : '',
        city_id: this.employee_data.city ? this.employee_data.city : '',
        office_country_id: this.employee_data.office_country ? this.employee_data.office_country : '',
        office_province_id: this.employee_data.office_province ? this.employee_data.office_province : '',
        office_city_id: this.employee_data.office_city ? this.employee_data.office_city : '',
        contract_start_date: this.contract_start_date ? this.$moment(this.employee_data.contract_start_date).format('YYYY-MM-DD') : null,
        contract_end_date: this.contract_end_date ? this.$moment(this.employee_data.contract_end_date).format('YYYY-MM-DD') : null,
        location_id: this.employee_data.company_location ? this.employee_data.company_location : '',
        address: this.employee_data.address ? this.employee_data.address : '',
        office_address: this.employee_data.office_address ? this.employee_data.office_address : '',
        address_2: '',
        address_3: '',
        post_code: '',
        iban: '',
        managers: [],
        salutation: '',
        passport_no: '',
        passport_issuing: '',
        passport_issuing_date: '',
        passport_nationality: '',
        employment_type_id: this.employee_data.employment_type_id ? this.employee_data.employment_type_id : 0,
        employment_subtype_id: this.employee_data.employment_subtype_id ? this.employee_data.employment_subtype_id : 0,
        roles: this.employee_data.role_names ? this.employee_data.role_names.map(val => val.id) : [],
      };
      return genData;
    },
  },
  created() {
    // this.getTypeEmployee();
  },
  methods: {
    ...mapActions('jStoreEmployee', ['updateEmployee', 'deleteEmployee', 'getTypeEmployee']),

    getData(data) {
      this.employee_data = data;
    },

    saveUpdateEmployee() {
      this.$refs.employeeForm.save();
      if (this.employee_data !== null) {
        this.updateEmployee(this.generateData);
      }
    },
    // deletedEmployee() {
    //   const text = 'You want to delete this data';

    //   this.$swal({
    //     title: 'Are you sure?',
    //     text,
    //     type: 'question',
    //     showCancelButton: true,
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes',
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteEmployee({ user_company_ids: [this.$route.params.id] });
    //     }
    //   });
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/detail/jDetail.vue